import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import {
  PoButtonModule,
  PoFieldModule,
  PoNotificationService,
  PoContainerModule
} from '@po-ui/ng-components';

import { LoginService } from '../../core/services/login.service';
import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule, PoButtonModule, PoFieldModule, PoContainerModule],
  templateUrl: './reset-password.html',
  styleUrls: ['./reset-password.css']
})
export class ResetPasswordComponent implements OnInit {

  token = '';
  newPassword = '';
  confirmPassword = '';
  loading = false;

  readonly logoUrl$: Observable<string>;
  //readonly secondaryLogoUrl$: Observable<string>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private login: LoginService,
    private theme: ThemeService,
    private notif: PoNotificationService
  ) {
    this.logoUrl$ = this.theme.logo$;
    //this.secondaryLogoUrl$ = this.theme.secondaryLogo$;
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') ?? '';
    if (!this.token) {
      this.notif.error({ message: 'Link invalido. Solicite um novo reset de senha.' });
      this.router.navigate(['/login']);
    }
  }

  submit(): void {
    if (this.newPassword.length < 8) {
      this.notif.warning({ message: 'A senha precisa ter no minimo 8 caracteres.' });
      return;
    }
    if (this.newPassword !== this.confirmPassword) {
      this.notif.warning({ message: 'As senhas nao conferem.' });
      return;
    }

    this.loading = true;
    this.login.resetPassword(this.token, this.newPassword)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.loading = false;
          this.notif.success({ message: 'Senha redefinida com sucesso. Faca login.' });
          this.router.navigate(['/login']);
        },
        error: () => {
          this.loading = false;
        }
      });
  }
}
